
import BaseApi from "../../../services/baseApi";

class Unit_se {
    constructor() {
        this.entity = 'unit';
    }


    getPage(page_,size_,id) {
        var formData = new FormData();
        formData.set("page",page_)
        formData.set("size", size_)
        formData.set("id", id)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data: formData,
            url: '/private/'+this.entity+'/list',
            headers: {'Content-Type': 'application/json'},
        })
    }



    search(value,buildingId,page_,size_){
        let search=value;
        let formData=new FormData();
        formData.set("page",page_)
        formData.set("size", size_)
        formData.append("search",search)
        formData.append("buildingId",buildingId)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data:formData,
            url: '/private/'+this.entity+'/search',
            headers: {'Content-Type': 'application/json'},
        })
    }

    getBuilding(){
        return BaseApi({requiresAtuh:true})({
            method:'GET',
            url: '/private/'+this.entity+'/getBuilding',
            headers: {'Content-Type': 'application/json'},
        })
    }

    saveByExcel(file,buildingId ) {
        let formData = new FormData();
        formData.set("file",file)
        formData.set("bId",buildingId)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data: formData,
            url: '/private/'+this.entity+'/saveByExcel/',
            headers: {'Content-Type': 'application/json'},
        })
    }


}
export default new Unit_se();
